import { useContext } from "react";
import Helper from "../classes/helper";
import FactoryContext from "../contexts/factoryContext";

/**
 *
 * @returns {?Helper}
 */
export default function useHelper() {
  const factory = useContext(FactoryContext);

  const loaded = !!factory;
  if (!loaded) return null;

  return new Helper(factory);
}
